import actionsTypes from './actionTypes';
import {
  IChangePropertyExtendedPayload,
  IAddCreditCardRequestPayload,
  IProcessRequestPayload,
  IConfirmCardAddedPayload,
  ISetupIntentCardRequestPayload,
  ISetupIntentCardSuccessPayload,
} from './types';
import {
  ChangePropertyAction,
  AddCreditCardRequestAction,
  AddCreditCardSuccessAction,
  AddCreditCardErrorAction,
  ProcessActionRequestAction,
  ClearCvvAction,
  ChangeModalVisibilityAction,
  ConfirmCardAction,
  setupIntentCardRequestAction,
  setupIntentCardSuccessAction,
} from './actions.d';

const actions = {
  changeProperty: (payload: IChangePropertyExtendedPayload): ChangePropertyAction => ({
    type: actionsTypes.CHANGE_PROPERTY,
    payload,
  }),

  addCreditCardRequest: <T1, T2>(
    payload: IAddCreditCardRequestPayload<T1, T2>,
  ): AddCreditCardRequestAction<T1, T2> => ({
    type: actionsTypes.ADD_CREDIT_CARD_REQUEST,
    payload,
  }),

  addCreditCardSuccess: (): AddCreditCardSuccessAction => ({
    type: actionsTypes.ADD_CREDIT_CARD_SUCCESS,
  }),

  addCreditCardError: (): AddCreditCardErrorAction => ({
    type: actionsTypes.ADD_CREDIT_CARD_ERROR,
  }),

  processActionRequest: <T1, T2>(payload: IProcessRequestPayload<T1, T2>): ProcessActionRequestAction<T1, T2> => ({
    type: actionsTypes.PROCESS_ACTION_REQUEST,
    payload,
  }),

  clearCvv: (): ClearCvvAction => ({
    type: actionsTypes.CLEAR_CVV,
  }),

  changeModalVisibility: (): ChangeModalVisibilityAction => ({
    type: actionsTypes.CHANGE_MODAL_VISIBILITY,
  }),

  confirmCardRequest: (payload: IConfirmCardAddedPayload): ConfirmCardAction => ({
    type: actionsTypes.CONFIRM_CARD_ADDED_REQUEST,
    payload,
  }),

  setupIntentCardRequest: (payload: ISetupIntentCardRequestPayload): setupIntentCardRequestAction => ({
    type: actionsTypes.SETUP_INTENT_CARD_REQUEST,
    payload,
  }),

  setupIntentCardSuccess: (payload: ISetupIntentCardSuccessPayload): setupIntentCardSuccessAction => ({
    type: actionsTypes.SETUP_INTENT_CARD_SUCCESS,
    payload,
  }),
};

export default actions;
